import type { RouteObject } from 'react-router-dom';
import Home from '@/pages/home/page';
import CategoryPage from '@/pages/category/page';
import ComicDetailPage from '@/pages/comic/[id]/page';
import ComicReadPage from '@/pages/comic/[id]/read/[chapter]/page';
import AboutPage from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/category',
    element: <CategoryPage />,
  },
  {
    path: '/comic/:id',
    element: <ComicDetailPage />,
  },
  {
    path: '/comic/:id/read/:chapter',
    element: <ComicReadPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <Home />,
  },
];

export default routes;